"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[716],{

/***/ 40716:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93298);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8013);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26029);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(49154);
/* harmony import */ var _opendoor_bricks_core_Icon_SelectiveSpritesheet__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87583);
/* harmony import */ var _opendoor_bricks_core_Icon_SpritesheetIcons_Close16__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80270);
/* harmony import */ var _helpers_queryParams__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43552);
/* storybook-check-ignore */ 





var MaintenanceBanner = function() {
    var maintenance_start_time_local = (0,_helpers_queryParams__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().maintenance_start_time_local;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(maintenance_start_time_local !== undefined), showBanner = ref[0], setShowBanner = ref[1];
    var closeBanner = function() {
        return setShowBanner(false);
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_opendoor_bricks_core_Icon_SelectiveSpritesheet__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                icons: [
                    _opendoor_bricks_core_Icon_SpritesheetIcons_Close16__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z
                ]
            }),
            showBanner && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                display: showBanner ? "flex" : "none",
                py: [
                    5,
                    5,
                    0
                ],
                pl: 7,
                // @ts-expect-error custom yellow
                backgroundColor: "#fff9e6",
                flexDirection: "row",
                justifyContent: [
                    null,
                    null,
                    "space-between"
                ],
                mx: "auto",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        maxWidth: "80%",
                        p: [
                            4,
                            4,
                            4,
                            7
                        ],
                        fontSize: [
                            "s1",
                            "s1",
                            "s1",
                            "s2"
                        ],
                        fontWeight: "semibold",
                        children: [
                            "Opendoor will be down for scheduled maintenance on ",
                            maintenance_start_time_local
                        ]
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                        variant: "ghost",
                        onClick: closeBanner,
                        id: "maintenance-banner-close-button",
                        "aria-label": "Close banner",
                        analyticsName: "cosmos-maintenance-banner-close",
                        p: 7,
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            name: "close",
                            size: 16,
                            "aria-hidden": "true"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (MaintenanceBanner);


/***/ })

}]);